import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62549cbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-main" }
const _hoisted_2 = { class: "container-site conteudo-footer" }
const _hoisted_3 = { class: "linha-footer" }
const _hoisted_4 = { class: "marca-footer" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "texto-marca" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nome-marca" }, " LimaTec "),
  /*#__PURE__*/_createElementVNode("span", { class: "slogan-marca" }, " Elétrica · Automação · Energia Solar ")
], -1))
const _hoisted_6 = { class: "links-footer" }
const _hoisted_7 = { class: "footer-midias" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "20",
  height: "20",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15 3h-2a4 4 0 0 0-4 4v3H6v4h3v7h4v-7h3l1-4h-4V7a1 1 0 0 1 1-1h2z" })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "20",
  height: "20",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "3.5",
    y: "3.5",
    width: "17",
    height: "17",
    rx: "5"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "17",
    cy: "7",
    r: "0.6"
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "20",
  height: "20",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M7 10v7M7 7v.01M11 17v-4a2.5 2.5 0 0 1 5 0v4M11 10v7" }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "3.5",
    y: "3.5",
    width: "17",
    height: "17",
    rx: "3"
  })
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "rodape-final" }
const _hoisted_18 = { class: "footer-title" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "footer-dev" }, [
  /*#__PURE__*/_createTextVNode(" Desenvolvido por "),
  /*#__PURE__*/_createElementVNode("strong", null, "LimaTec")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoLimaTec = _resolveComponent("LogoLimaTec")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_LogoLimaTec, {
            Altura: "46px",
            class: "logo-footer"
          }),
          _hoisted_5
        ]),
        _createElementVNode("nav", _hoisted_6, [
          _createElementVNode("a", {
            href: "#empresa",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.rolarPara('empresa')), ["prevent"]))
          }, " Sobre nós "),
          _createElementVNode("a", {
            href: "#servicos",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.rolarPara('servicos')), ["prevent"]))
          }, " Serviços "),
          _createElementVNode("a", {
            href: "#orcamento",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.rolarPara('orcamento')), ["prevent"]))
          }, " Orçamento "),
          _createElementVNode("a", {
            href: "#contato",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.rolarPara('contato')), ["prevent"]))
          }, " Contato ")
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", {
            href: _ctx.LinkFacebook,
            target: "_blank",
            rel: "noopener",
            "aria-label": "Facebook da LimaTec"
          }, _hoisted_10, 8, _hoisted_8),
          _createElementVNode("a", {
            href: _ctx.LinkInstagram,
            target: "_blank",
            rel: "noopener",
            "aria-label": "Instagram da LimaTec"
          }, _hoisted_13, 8, _hoisted_11),
          _createElementVNode("a", {
            href: _ctx.LinkLinkedin,
            target: "_blank",
            rel: "noopener",
            "aria-label": "LinkedIn da LimaTec"
          }, _hoisted_16, 8, _hoisted_14)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.Titulo), 1),
        _hoisted_19
      ])
    ])
  ]))
}